import React from 'react';
import { formatCurrency } from '../../../utils/formatters';

const OrderTotalsDisplay = ({ orderTotals, primaryCurrency, totalShippingCost, allShippingRates, /* transactionType, */ securityDeposit, hasValidItems }) => {
  if (!hasValidItems) {
    return (
      <div className="border-t border-gray-200 pt-4">
        <div className="flex justify-between text-sm mb-2">
          <span>Subtotal (shippable items)</span>
          <span>{formatCurrency(0, primaryCurrency)}</span>
        </div>
        
        <div className="flex justify-between text-sm mb-2">
          <span>Platform Fee</span>
          <span>{formatCurrency(0, primaryCurrency)}</span>
        </div>
        
        <div className="flex justify-between text-sm mb-2">
          <span>Shipping</span>
          <span className="text-gray-500">Free</span>
        </div>
        
        <div className="flex justify-between text-sm mb-2">
          <span>Tax</span>
          <span>{formatCurrency(0, primaryCurrency)}</span>
        </div>
        
        <div className="flex justify-between text-base font-medium mt-4 pt-4 border-t">
          <span>Total</span>
          <span>{formatCurrency(0, primaryCurrency)}</span>
        </div>
        
        {/* <div className="mt-4 text-center text-red-500 font-medium">
          No valid items available for shipping to this address
        </div> */}
      </div>
    );
  }

  return (
    <div className="border-t border-gray-200 pt-4">
      <div className="flex justify-between text-sm mb-2">
        <span>Subtotal (shippable items)</span>
        <span>{formatCurrency(orderTotals.subtotal, primaryCurrency)}</span>
      </div>
      
      <div className="flex justify-between text-sm mb-2">
        <span>Platform Fee</span>
        <span>{formatCurrency(orderTotals.platformFee, primaryCurrency)}</span>
      </div>
      
      <div className="flex justify-between text-sm mb-2">
        <span>Shipping</span>
        <span>
          {totalShippingCost > 0 ? (
            <span className="flex flex-col items-end">
              <span>{formatCurrency(totalShippingCost, primaryCurrency)}</span>
              {allShippingRates.length > 0 && (
                <span className="text-xs text-gray-500">
                  {allShippingRates.length === 1 
                    ? `${allShippingRates[0].service || allShippingRates[0].serviceName} (${allShippingRates[0].provider || allShippingRates[0].carrier})`
                    : `${allShippingRates.length} shipping methods`}
                </span>
              )}
            </span>
          ) : (
            <span className="text-gray-500">Free</span>
          )}
        </span>
      </div>
      
      <div className="flex justify-between text-sm mb-2">
        <span>Tax</span>
        <span>{formatCurrency(orderTotals.tax, primaryCurrency)}</span>
      </div>
      
      {securityDeposit > 0 && (
        <div className="flex justify-between text-sm mb-2">
          <span className="flex items-center">
            Security Deposit
            <span className="ml-1 text-gray-500 hover:text-gray-700 cursor-help" title="This amount will be refunded after the rental period, assuming the item is returned in good condition.">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </span>
          </span>
          <span>{formatCurrency(securityDeposit, primaryCurrency)}</span>
        </div>
      )}
      
      <div className="flex justify-between text-base font-medium mt-4 pt-4 border-t">
        <span>Total</span>
        <span>{formatCurrency(orderTotals.total + (securityDeposit > 0 ? securityDeposit : 0), primaryCurrency)}</span>
      </div>
    </div>
  );
};

export default OrderTotalsDisplay; 